// Fuente unica de verdad para los modulos del sistema de permisos.
// Debe coincidir con MODULO_KEYS en backend/app/models/permisos.py.
import React from "react";

export const MODULOS = [
  { key: "productos", label: "Productos", icon: <i className="fa-solid fa-compact-disc" />, path: "/app/productos" },
  { key: "servicios", label: "Servicios", icon: <i className="fa-solid fa-print" />, path: "/app/servicios" },
  { key: "proveedores", label: "Proveedores", icon: <i className="fa-solid fa-truck-field" />, path: "/app/proveedores" },
  { key: "clientes", label: "Clientes", icon: <i className="fa-solid fa-address-book" />, path: "/app/clientes" },
  { key: "compras", label: "Compras", icon: <i className="fa-solid fa-cart-arrow-down" />, path: "/app/compras" },
  { key: "ventas", label: "Ventas", icon: <i className="fa-solid fa-receipt" />, path: "/app/ventas" },
  { key: "cajero", label: "Cajero", icon: <i className="fa-solid fa-cash-register" />, path: "/app/cajero" },
  { key: "cortes", label: "Cortes de Caja", icon: <i className="fa-solid fa-vault" />, path: "/app/cortes" },
  { key: "gastos", label: "Gastos", icon: <i className="fa-solid fa-money-bill-wave" />, path: "/app/gastos" },
  { key: "promociones", label: "Promociones", icon: <i className="fa-solid fa-tag" />, path: "/app/promociones" },
  { key: "reparaciones", label: "Reparaciones", icon: <i className="fa-solid fa-screwdriver-wrench" />, path: "/app/reparaciones" },
  { key: "encargos", label: "Encargos/Apartados", icon: <i className="fa-solid fa-box-archive" />, path: "/app/encargos" },
  { key: "facturacion", label: "Facturacion", icon: <i className="fa-solid fa-file-invoice-dollar" />, path: "/app/facturacion" },
  { key: "estadisticas", label: "Estadisticas", icon: <i className="fa-solid fa-chart-simple" />, path: "/app/estadisticas" },
  { key: "usuarios", label: "Usuarios", icon: <i className="fa-solid fa-user" />, path: "/app/usuarios" },
  { key: "configuracion", label: "Configuracion", icon: <i className="fa-solid fa-gear" />, path: "/app/configuracion" },
];

export const MODULO_KEYS = MODULOS.map((m) => m.key);

export const MODULOS_BY_KEY = Object.fromEntries(MODULOS.map((m) => [m.key, m]));

export const ACTIONS = [
  { key: "modulo", label: "Modulo" },
  { key: "consultar", label: "Consultar" },
  { key: "insertar", label: "Insertar" },
  { key: "editar", label: "Editar" },
  { key: "eliminar", label: "Eliminar" },
];

export const ACTION_KEYS = ACTIONS.map((a) => a.key);
